require('./bootstrap');

/* Lazyloading */
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

//simple support for background images:
document.addEventListener('lazybeforeunveil', function(e) {
  var bg = e.target.getAttribute('data-bg');
  if (bg) {
    e.target.style.backgroundImage = 'url(' + bg + ')';
  }
});

/**
 * Scrolling
 */

var scrollIntoView = require('scroll-into-view');

var scrollElements = document.querySelectorAll('.scrollto');

scrollElements.forEach((element) => {
  element.addEventListener('click', function(e) {
    e.preventDefault();
    if (e.target.getAttribute('href') == null) {
      scrollIntoView(document.querySelector(e.target.closest('a').getAttribute('href')));
    } else {
      scrollIntoView(document.querySelector(e.target.getAttribute('href')));
    }
  });
});

/**
 * Vue.js
 */

window.Vue = require('vue');

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
//import { required , min , email , regex } from 'vee-validate/dist/rules';
//import nl from 'vee-validate/dist/locale/nl.json';
import * as rules from 'vee-validate/dist/rules';
import nl from 'vee-validate/dist/locale/nl.json';

for (let rule in rules) {
  extend(rule, {
    ...rules[rule],
    message: nl.messages[rule],
  });
}

/*extend(required, { ...required, message: nl.messages[required] });
extend(min, { ...min, message: nl.messages[min] });
extend(email, { ...email, message: nl.messages[email] });
extend(regex, { ...regex, message: nl.messages[regex] });*/

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map((key) =>
  Vue.component(
    key
      .split('/')
      .pop()
      .split('.')[0],
    files(key).default,
  ),
);

/**
 * Create Vue Instances
 */

// Main Vue instance
export const bus = new Vue();

const app = new Vue({
  el: '#app',

  data: {
    navigationIsVisble: false,
    stickyNavigation: false,
  },

  mounted() {
    this.init();
    const self = this;

    window.addEventListener('resize', () => {
      self.init();
    });

    window.addEventListener('orientationchange', () => {
      self.init();
    });

    let last_known_scroll_position = 0;
    let ticking = false;
    window.addEventListener('scroll', function(e) {
      last_known_scroll_position = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(function() {
          if (last_known_scroll_position > 0) {
            self.stickyNavigation = true;
          } else {
            self.stickyNavigation = false;
          }

          ticking = false;
        });

        ticking = true;
      }
    });

    const headerHeight = document.getElementsByTagName('header').length > 0 ? document.getElementsByTagName('header')[0].clientHeight : 0;
    const topOffset = window.innerWidth < 767.98 ? headerHeight + 150 : headerHeight + 120;

    const scrollOptions = {
      align: {
        top: 0,
        topOffset: topOffset,
      },
    };

    this.scrollOptions = scrollOptions;

    const scrollElements = document.querySelectorAll("a[href^='#']");
    scrollElements.forEach((element) => {
      if (element.getAttribute('href') !== '#') {
        element.addEventListener('click', function(e) {
          e.preventDefault();
          if (e.target.getAttribute('href') == null) {
            let target = e.target.closest('a').getAttribute('href');
            scrollIntoView(document.querySelector(target), scrollOptions, function() {
              history.pushState({}, '', target);
            });
          } else {
            let target = e.target.getAttribute('href');
            scrollIntoView(document.querySelector(target), scrollOptions, function() {
              history.pushState({}, '', target);
            });
          }
        });
      }
    });

    var coll = document.getElementsByClassName('collapsible');
    var i;

    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener('click', function() {
        this.classList.toggle('active');
        var content = this.nextElementSibling;
        this.nextElementSibling.classList.toggle('content-active');
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    }
  },

  methods: {
    init() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      this.isMobile = window.innerWidth < 767.98;
    },

    toggleBodyClass: function(className) {
      document.getElementsByTagName('body')[0].classList.toggle(className);
    },

    scrollIntoView(element) {
      scrollIntoView(element, this.scrollOptions);
    },
  },

  watch: {},
});
